<template>
  <div>
    <div class="real-data">
      <div class="data-item" v-for="(rItem, rIndex) in realTimeData" :key="rIndex + 'realData'">
        <div class="data-line">
          <div class="line-top">
            <span class="name">{{rItem.name}}</span>
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{rItem.tips}}</span>
              </template>
              <img src="@/assets/images/icon-question.png" alt="">
            </a-tooltip>
          </div> 
          <span class="value" :style="{'color' : rIndex == 0 ? '#FF3A00' : ''}"><span v-if='rIndex == 0'>¥</span>{{rItem.value ? rIndex == 0 ? (+rItem.value).toFixed(2) : rItem.value : 0}}</span>
          <span class="pre">
            <span class="left">昨日</span>
            <span class="right"><span v-if='rIndex == 0'>¥</span>{{rItem.pre ? rIndex == 0 ? (+rItem.pre).toFixed(2) : rItem.pre : 0}}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="top-data">
      <span class="title">实时成交榜单</span>
      <div class="product" v-if="saleAmtTopNodeList && saleAmtTopNodeList.length > 0">
        <template v-for="(topItem, topIndex) in saleAmtTopNodeList">
          <div class="pro-item" :key="topIndex + 'top'">
            <img :src="topItem.url" alt="">
            <div class="pro-item-data">
              <div class="shop-name">{{topItem.spu_name}}</div>
              <div class="item-line"><span>成交金额</span><span class="value">¥{{(+topItem.sale_amt).toFixed(2)}}</span></div>
            </div>
          </div>
        </template>
      </div>
      <a-empty v-else/>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'ant-design-vue'
import { Empty } from 'ant-design-vue'
import _ from 'lodash'
import moment from 'moment'
export default {
  props: {
    updateTime: {
      type:String,
      default: ''
    }
  },
  data () {
    return {
      realTimeData:[],
      saleAmtTopNodeList: [],
    }
  },
  components: {
    [Empty.name]: Empty,
    [Tooltip.name]: Tooltip
  },
  created() {
    this.queryRealTimeDate()
    this.queryTopData()
  },
  methods: {
    // 获取实时成交榜
    async queryTopData () {
      let topRes  = await this.$store.dispatch('popHome/queryTopData')
      this.saleAmtTopNodeList = _.get(topRes, ['data', 'saleAmtTopNodeList'], []).slice(0,5)
    },
    // 获取实时数据
    async queryRealTimeDate() {
      let relRes = await this.$store.dispatch('popHome/queryRealTimeDate')
      this.realTimeData = []
      this.realTimeData.push({
        name:'成交总金额',
        value: _.get(relRes, ['data', 'tradeAmt', 'todayNum'], 0),
        pre: _.get(relRes, ['data', 'tradeAmt', 'ydayNum'], 0),
        tips:'统计周期内，成功支付的累计订单金额'
      })
      this.realTimeData.push({
        name:'成交总单量',
        value: _.get(relRes, ['data', 'tradeCount', 'todayNum'], 0),
        pre: _.get(relRes, ['data', 'tradeCount', 'ydayNum'], 0),
        tips:'统计周期内，成交支付的累计订单数量'
      })
      this.realTimeData.push({
        name:'成交客户数',
        value: _.get(relRes, ['data', 'tradeBuyerNum', 'todayNum'], 0),
        pre: _.get(relRes, ['data', 'tradeBuyerNum', 'ydayNum'], 0),
        tips:'统计周期内，成功支付的用户数量。统计时间段内，同一用户产生多笔订单会去重计算'
      })
      this.realTimeData.push({
        name:'访客数',
        value: _.get(relRes, ['data', 'uv', 'todayNum'], 0),
        pre: _.get(relRes, ['data', 'uv', 'ydayNum'], 0),
        tips:'统计周期内，店铺各页面访问人数。同一访客多次访问只被计算一次'
      })
      this.realTimeData.push({
        name:'浏览量',
        value: _.get(relRes, ['data', 'pv', 'todayNum'], 0),
        pre: _.get(relRes, ['data', 'pv', 'ydayNum'], 0),
        tips:'统计周期内，店铺各页面访问次数，同一用户在统计时间内'
      })
      this.$emit('update:updateTime', moment(_.get(relRes, ['data', 'pv', 'updateTime'])).format('YYYY.MM.DD HH:mm:ss'))
    }
  }
}
</script>

<style lang="scss" scoped>
.real-data {
  display: flex;
  width: 100%;
  .data-item {
    width: 20%;
    .data-line {
      width: 85%;
      display: flex;
      flex-direction: column;
      font-family: MicrosoftYaHei;
      letter-spacing: 0;
      border-right: 1px solid #f6f6f6;
      .line-top {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .name {
          font-size: 14px;
          color: #666666;
          margin-right: 4px;
        }
        img {
          width: 14px;
          height: 14px;
          flex-shrink: 0;
        }
      }
      .value {
        font-size: 20px;
        color: #333333;
        line-height: 17px;
        margin-bottom: 10px;
      }
      .pre {
        display: flex;
        align-items: center;
        font-size: 12px;
        .left {
          color: #999999;
          margin-right: 10px;
        }
        .right {
          color: #666666;
        }
      }
    }
  }
  .data-item:last-child .data-line {
    border-right:0px !important;
  }
}
.top-data {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    margin-bottom: 10px;
  }
  .product {
    display: flex;
    flex-wrap: wrap;
    .pro-item {
      width: 33%;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      img {
        width: 60px;
        height: 60px;
        flex-shrink: 0;
        margin-right: 10px;
      }
      .pro-item-data {
        display: flex;
        flex-direction: column;
        font-family: MicrosoftYaHei;
        font-size: 13px;
        .shop-name {
          width: 105px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
          margin-bottom: 4px;
        }
        .item-line {
          display: flex;
          align-items: center;
          width: 105px;
          justify-content: space-between;
          color: #666666;
          letter-spacing: 0;
          .value {
            color: #333;
          }
        }
      }
    }
  }
}
</style>
